import { render, staticRenderFns } from "./PrivacyPolicyLayout.vue?vue&type=template&id=5287dcde&scoped=true&"
import script from "./PrivacyPolicyLayout.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287dcde",
  null
  
)

export default component.exports